export default __webpack_public_path__ + "static/media/new-pitch-mob-cricket.2fcc418b.png";